import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ActivityDataProvider } from "../../data-provider/activity.dp";
import { IssueDataProvider } from "../../data-provider/issue.dp";
import { Campaign } from "../../models/campaign.model";
import { HouseOccupant } from "../../models/house-occupant.model";
import { PermissionCheck } from "../../shared/permission";
import { CanvassService } from "../../services/canvass.service";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { IssueService } from "../../services/issue.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { Issue } from "../../models/issue.model";

let ViewHouseOccupantComponent = {
    selector: "vcViewHouseOccupant",
    templateUrl:
        "/angular/components/house-occupant/view-house-occupant.component.html",
    bindings: {
        selectedHoid: "=",
    },
    controller: class ViewHouseOccupantController {
        // * bindings for typescript compiler *
        public selectedHoid: any;
        // ************************************

        public activityItems: any = [];
        public personLink = false;
        public activeCampaign: Campaign;
        public essentialsMode: boolean;
        public isLeaderView: boolean;
        public houseoccupant: HouseOccupant;
        public countLabels: any | undefined = undefined;

        private $scope: any;
        private __env: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private modelsUtils: any;

        public houseOccupantDataProvider: HouseOccupantDataProvider;
        public houseOccupantResource: HouseOccupantService;
        public activityDataProvider: ActivityDataProvider;
        public issueDataProvider: IssueDataProvider;
        public permissionProvider: PermissionCheck;
        public issueService: IssueService;
        public canvassService: CanvassService;

        constructor(
            $scope: any,
            __env: any,
            __app_type: string,
            HouseOccupantService: HouseOccupantService,
            HouseOccupantDataProvider: HouseOccupantDataProvider,
            IssueService: IssueService,
            CampaignDataProvider: CampaignDataProvider,
            ActivityDataProvider: ActivityDataProvider,
            IssueDataProvider: IssueDataProvider,
            CanvassService: CanvassService,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;

            this.houseOccupantDataProvider = HouseOccupantDataProvider;
            this.houseOccupantResource = HouseOccupantService;
            this.issueService = IssueService;
            this.activityDataProvider = ActivityDataProvider;
            this.issueDataProvider = IssueDataProvider;
            this.canvassService = CanvassService;
            this.permissionProvider = PermissionCheck;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            this.activityDataProvider
                .getHouseOccupantActivity(this.selectedHoid)
                .then((activity: any) => {
                    this.activityItems = activity;
                });

            this.$scope.$on("$routeChangeStart", () => this.dialog.hide());

            this.houseOccupantResource
                .info(this.selectedHoid)
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.houseoccupant = this.modelsUtils.houseOccupant(
                            json.data
                        );
                        if (
                            angular.isDefined(this.houseoccupant.hodob) &&
                            this.houseoccupant.hodob
                        ) {
                            this.splitDOB();
                        }
                    }
                });
        }

        openEditHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-house-occupant-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                        selectedHid: null,
                    },
                    ariaLabel: "Person",
                    size: "large",
                })
                .then((data: any) => {
                    this.houseoccupant.setData(data);
                    this.houseoccupant.customfields = data.customfields;
                });
        }

        openIssueDialog(hoid: string, ev: object): void {
            this.dialog
                .show({
                    component: "vc-create-issue",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Change Custom Field",
                    class: "create-issue-dialog",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: null,
                        selectedHoid: hoid,
                        selectedCanvasser: null,
                        dialogType: "houseoccupant",
                    },
                })
                .then((issueData: object) => {
                    this.issueService
                        .create(issueData)
                        .then((response: object) => {
                            const json = response["data"];
                            json.data.atype = "issue";
                            this.activityItems.unshift(json.data);
                            this.toast.success("Logged follow-up request.");
                        });
                });
        }

        deleteCanvass(canvass: any, ev: object): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: "Delete Interaction?",
                        bodyText:
                            "This will permanently delete the interaction",
                    },
                })
                .then(() => {
                    this.canvassService
                        .delete({ id: canvass.csid })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                let index = this.activityItems.indexOf(canvass);
                                this.activityItems.splice(index, 1);
                                this.toast.success("Interaction deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        deletePersonDialog(houseoccupant: HouseOccupant, ev: object): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete ${houseoccupant.hofname} ${houseoccupant.holname}?`,
                        bodyText: `All interactions, survey data, follow-up requests, contact details and any other data associated with this ${this.__env.strings.voter} will be permanently deleted`,
                    },
                })
                .then(() => {
                    this.houseOccupantDataProvider
                        .delete(houseoccupant)
                        .then((returnedHouseOccupant: HouseOccupant) => {
                            this.toast.success("Contact deleted.");
                            returnedHouseOccupant.deleted = true;
                            this.dialog.hide(returnedHouseOccupant);
                        });
                });
        }

        openCanvassDialog(canvass: any, ev: object): void {
            this.dialog
                .show({
                    component: "vc-canvass-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedHouseOccupant: this.houseoccupant,
                        selectedHouse: null,
                        selectedCanvass: canvass,
                    },
                    size: "large",
                    ariaLabel: "Interaction",
                })
                .then((data: any) => {
                    if (!canvass || !canvass.csid) {
                        data.atype = "canvass";
                        this.activityItems.unshift(data);
                    } else {
                        if (!data.issue) {
                            canvass.issue = null;
                        }
                        if (!data.survey) {
                            canvass.survey = null;
                        }
                        _.merge(canvass, data);
                    }
                    if (this.houseoccupant) {
                        this.houseoccupant.setData(data.houseoccupant);
                    }
                    this.updateCustomFields(
                        data.customfields,
                        this.houseoccupant.customfields
                    );

                    this.activityDataProvider
                        .getHouseOccupantActivity(this.selectedHoid)
                        .then((activity: object) => {
                            this.activityItems = activity;
                        });
                });
        }

        updateCustomFields(
            newCustomFields: any[],
            oldCustomFields: any[]
        ): void {
            angular.forEach(newCustomFields, (newCustomField: any) => {
                angular.forEach(oldCustomFields, (oldCustomField: any) => {
                    if (newCustomField.cfid == oldCustomField.cfid) {
                        // oldCustomField = newCustomField;
                        if (
                            newCustomField.cftid == 4 &&
                            newCustomField.option
                        ) {
                            newCustomField.value =
                                newCustomField.option.cfoname;
                            newCustomField.hocfvalue =
                                newCustomField.option.cfoname;
                        }
                        if (newCustomField.cftid == 5) {
                            let value_string = "";
                            angular.forEach(
                                newCustomField.options,
                                (option: any) => {
                                    if (option.selected == 1) {
                                        value_string += option.cfoname + ",";
                                    }
                                }
                            );
                            value_string = value_string.substring(
                                0,
                                value_string.length - 1
                            );
                            newCustomField.value = value_string;
                            newCustomField.hocfvalue = value_string;
                        }
                        _.merge(oldCustomField, newCustomField);
                    }
                });
            });
        }

        openSummaryDialog(canvass: any, ev: object): void {
            this.dialog.show({
                component: "vc-view-summary-dialog",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    signature: canvass.signature,
                    summary: canvass.summary,
                },
            });
        }

        openDeleteIssueDialog(issue: Issue, ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Delete Issue",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: issue,
                    },
                })
                .then((data: Issue) => {
                    this.issueDataProvider.deleteIssue(data).then(() => {
                        let index = this.activityItems.indexOf(issue);
                        this.activityItems.splice(index, 1);
                        this.toast.success("Issue deleted");
                        this.countLabels =
                            this.issueDataProvider.getMailboxLabels();
                    });
                });
        }

        splitDOB(): void {
            if (angular.isDefined(this.houseoccupant.hodob)) {
                let pieces = this.houseoccupant.hodob.split("-");
                if (pieces.length == 3) {
                    this.houseoccupant.hoybirthday = pieces[0];
                    this.houseoccupant.hombirthday = pieces[1];
                    this.houseoccupant.hodbirthday = pieces[2];
                }
            }
        }

        closeDialog(houseoccupant: HouseOccupant): void {
            this.dialog.hide(houseoccupant);
        }
    },
};

angular
    .module("houseoccupant")
    .component(ViewHouseOccupantComponent.selector, ViewHouseOccupantComponent);
